import { render, staticRenderFns } from "./equipment5.vue?vue&type=template&id=579521a4&scoped=true"
import script from "./equipment5.vue?vue&type=script&lang=js"
export * from "./equipment5.vue?vue&type=script&lang=js"
import style0 from "./equipment5.vue?vue&type=style&index=0&id=579521a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579521a4",
  null
  
)

export default component.exports